import axios from "../axios";
import { useNavigate } from "react-router-dom";
import "../assets/styles/LandingAfterLogin.css";
import { useState, useEffect } from "react";
import logo from "../assets/images/swaasa-logo.png";

export default function LandingAfterLogin() {
  useEffect(() => {
    setTimeout(function () {
      if (localStorage.getItem("isTrial") == "true") {
        navigate("/trial-user");
      } else if (localStorage.getItem("isTrial") == "false") {
        navigate("/subscribed-user");
      }
    }, 0);
  }, []);

  useEffect(() => {
    getProfileApi();
  }, []);

  const [balance, setBalance] = useState("");
  const [phoneNumber, setPhoneNo] = useState("");
  const [userId, setUserId] = useState("");
  const navigate = useNavigate();

  const goToConfirmAgreement = (balance, expiryDate) => {
    navigate("/update-profile", {
      state: {
        availableBalance: balance,
        expiryDate: expiryDate,
        totalAssessments: 50,
      },
    });
  };

  const getProfileApi = () => {
    axios
      .get("/getProfile", {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "*",
          accessToken: localStorage.getItem("accessToken"),
        },
      })
      .then((response) => {
        console.log(response);
        setPhoneNo(response.data.data.contact);
        const userId =
          response.data.data.loginId || localStorage.getItem("userId");
        setUserId(userId);
        UserBalanceCountApi(userId);
        localStorage.setItem("userName", response.data.data.firstname);
      });
  };

  const addAssessmentsApi = (doctorId, assessmentsFunds) => {
    const encodedUserId =
      typeof doctorId === "number"
        ? encodeURIComponent(String(doctorId))
        : encodeURIComponent(doctorId);
    axios
      .post(
        `/add_assessments?doctorId=${encodedUserId}&assessments_funds=${assessmentsFunds}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "*",
            accessToken: localStorage.getItem("accessToken"),
          },
        }
      )
      .then((response) => {
        console.log("Response: ", response);
        goToConfirmAgreement(
          response.data.available_balance,
          response.data.expiry_date
        );
      });
  };

  const UserBalanceCountApi = (userId) => {
    const encodedUserId =
      typeof userId === "number"
        ? encodeURIComponent(String(userId))
        : encodeURIComponent(userId);

    axios
      .get(`/user_balance_count?doctorId=${encodedUserId}`, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "*",
          accessToken: localStorage.getItem("accessToken"),
        },
      })
      .then((response) => {
        console.log("Response: ", response);
        setBalance(response.data.balance_info);
      })
      .catch((error) => {
        console.error("Error: ", error);
      });
  };
  // console.log(userId, 'userId')
  const updatePaymentApi = (
    razorpayOrderId,
    razorpaySignature,
    razorpayPaymentId,
    userId,
    orderId
  ) => {
    let formData = {
      razorpay_order_id: razorpayOrderId,
      razorpay_signature: razorpaySignature,
      razorpay_payment_id: razorpayPaymentId,
      userId: userId,
      order_id: orderId,
    };

    axios
      .post(`/update_payment`, formData, {
        headers: {
          accessToken: localStorage.getItem("accessToken"),
        },
      })
      .then((response) => {
        console.log("Response: ", response);
        return addAssessmentsApi(userId, 50);
      });
  };

  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  async function displayRazorpay() {
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );
    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    const result = await axios.post(
      "/payments/initiate_payment",
      {
        amount: 335000,
        currency: "INR",
      },
      {
        headers: {
          accessToken: localStorage.getItem("accessToken"),
        },
      }
    );
    if (!result) {
      alert("Server error. Are you online?");
      return;
    }
    const { amount, id: order_id, currency } = result.data.data;
    const orderId = result.data.data.order_id;
    console.log("orderId: ", orderId);
    var options = {
      key: process.env.REACT_APP_RAZORPAY_CLIENT_ID, // Enter the Key ID generated from the Dashboard
      amount: amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      currency: currency,
      name: "Swaasa",
      description: "Test Transaction",
      image: logo,
      order_id: orderId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
      handler: function (response) {
        console.log("Response: ", response);
        console.log(
          "response.razorpay_payment_id: ",
          response.razorpay_payment_id
        );
        console.log("response.razorpay_order_id: ", response.razorpay_order_id);
        console.log(
          "response.razorpay_signature: ",
          response.razorpay_signature
        );
        if (
          response.razorpay_payment_id != null &&
          response.razorpay_order_id != null &&
          response.razorpay_signature != null
        ) {
          updatePaymentApi(
            response.razorpay_order_id,
            response.razorpay_signature,
            response.razorpay_payment_id,
            userId,
            orderId
          );
        }
      },
      prefill: {
        // name: "ABC",
        email: userId,
        contact: phoneNumber,
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#3399cc",
      },
    };
    var rzp1 = new window.Razorpay(options);
    rzp1.on("payment.failed", function (response) {
      // alert(response.error.code);
      // alert(response.error.description);
      // alert(response.error.source);
      // alert(response.error.step);
      // alert(response.error.reason);
      // alert(response.error.metadata.order_id);
      // alert(response.error.metadata.payment_id);
    });
    rzp1.open();
    // document.getElementById("rzp-button1").onclick = function (e) {
    //   rzp1.open();
    //   e.preventDefault();
    // };
  }

  return (
    <div className="LandingAfterLogin">
      <span className="LandingAfterLogin-Head-text">
        Welcome to Swaasa Subscription
      </span>
      <div className="LandingAfterLogin-boxes">
        <div className="LandingAfterLogin-boxes-balance-box">
          <span className="LandingAfterLogin-boxes-balance-box-banaceText">
            Balance
          </span>
          <span className="LandingAfterLogin-boxes-balance-box-banace">
            {balance}{" "}
            <span className="LandingAfterLogin-boxes-balance-box-assessmentsLeft">
              {balance > 1 ? "assessments" : "assessment"}
            </span>
          </span>

          <span className="LandingAfterLogin-boxes-balance-box-warningText">
            You are running out of limit. Subscribe soon.!
          </span>
          <span style={{ borderBottom: "1px solid lightgray" }}></span>
          <span className="LandingAfterLogin-boxes-balance-box-currentPlansText">
            Current Plans
          </span>
          <div className="LandingAfterLogin-boxes-balance-box-planBox">
            <span className="LandingAfterLogin-boxes-balance-box-planBox-freeplanText">
              Free Plan
            </span>
            <span className="LandingAfterLogin-boxes-balance-box-planBox-10assessmentsonly">
              10 Assessments Only
            </span>
            <span className="LandingAfterLogin-boxes-balance-box-planBox-subformoreassessments">
              - Subscribe to have access for more assessments.
            </span>
          </div>
        </div>
        <div className="LandingAfterLogin-boxes-purchase-box">
          <span className="LandingAfterLogin-boxes-purchase-box-purchaseText">
            Purchase
          </span>
          <div className="LandingAfterLogin-boxes-purchase-box-subscriptionBox">
  
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                alignItems: "baseline",
                width: "fit-content",
                marginLeft: "auto",
                marginRight: "auto",
                marginTop: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "end",
                }}
              >
                <div style={{ display: "grid", width: "fit-content" }}>
                  <span className="LandingAfterLogin-boxes-purchase-box-subscriptionBox-subscriptionText">
                    Reg Fee
                  </span>
                  <span style={{fontWeight:'bold'}}>
                    <span style={{ fontFamily: "math" }}>₹</span> 850
                  </span>
                </div>
                <span>+</span>
              </div>
              <div style={{ display: "flex", gap: "20px", alignItems: "end" }}>
                <div style={{ display: "grid", width: "fit-content" }}>
                  <span className="LandingAfterLogin-boxes-purchase-box-subscriptionBox-subscriptionText">
                    Subscription
                  </span>
                  <span style={{fontWeight:'bold'}}>
                    <span style={{ fontFamily: "math" }}>₹</span> 2500
                  </span>
                </div>
                <span>=</span>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div style={{ display: "grid", width: "fit-content" }}>
                  <span className="LandingAfterLogin-boxes-purchase-box-subscriptionBox-subscriptionText">
                    Total
                  </span>
                  <span style={{fontWeight:'bold'}}>
                    <span style={{ fontFamily: "math" }}>₹</span> 3350
                  </span>
                </div>
                <span className="LandingAfterLogin-boxes-purchase-box-subscriptionBox-amount">
                  {/* <span>
                    <span style={{ fontFamily: "math" }}>₹</span> 2500
                  </span> */}
                  <span className="LandingAfterLogin-boxes-purchase-box-subscriptionBox-gst">
                    GST Incl
                  </span>
                </span>
              </div>
            </div>
            <span className="LandingAfterLogin-boxes-purchase-box-subscriptionBox-info">
              - First subscription fee includes registration charges
            </span>
            <span className="LandingAfterLogin-boxes-purchase-box-subscriptionBox-info">
              - Package unit of 50 assessments valid for 1 year
            </span>
          </div>
          {/* <div
            style={{
              backgroundColor: "#f0f0f0",
              padding: "10px",
              textAlign: "center",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            Note: Only QR and credit card payments are acceptable
          </div> */}
          <span
            onClick={displayRazorpay}
            className="LandingAfterLogin-boxes-purchase-box-makePaymentBtn"
          >
            Initiate Payment &#8594;
          </span>
        </div>
      </div>
    </div>
  );
}
